import { module } from 'angular';
import modalComponent from '../../components/modal/modal.module';

export default module('modal', [
	modalComponent,
]).name;
